var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"title":"Report Section","width":"1140","height":"541.25","src":"https://app.powerbi.com/view?r=eyJrIjoiZjFlNDFlNTMtZDEyYS00MmUyLTlmODAtZTJiNjYzNjJhNjZmIiwidCI6IjA4ZjI1MDAzLWE0NWMtNDlmYi04MDkwLWE4ZTljNDU5MjVkNiJ9","frameborder":"0","allowFullScreen":"true"}})])
}]

export { render, staticRenderFns }